import { Box, Button, Typography, Link, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { AuthContext } from './AuthProvider';
import { useTheme } from '@mui/material/styles';

// Reusable alignment styles
const FLEX_START_CENTER_ALIGNMENT = { xs: 'flex-start', md: 'center' };
const FLEX_DISPLAY = 'flex';

export default function MigrationBanner() {
  const { t } = useTranslation();
  const { user, actions } = useContext(AuthContext);
  const [isVisible, setIsVisible] = useState(true);
  const theme = useTheme();

  if (user || !isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        background: theme.palette.custom.migrationBanner.background,
        borderTop: `4px solid ${theme.palette.warning.main}`,
        py: 3,
      }}
    >
      <Container maxWidth='lg'>
        <Box
          sx={{
            display: FLEX_DISPLAY,
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: FLEX_START_CENTER_ALIGNMENT,
            gap: { xs: 3, md: 2 },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant='h4'
              sx={{ color: theme.palette.custom.titleDark, mb: 0.5 }}
            >
              {t('migrationBanner.title')}
            </Typography>
            <Typography variant='body2' color='text.primary' sx={{ mb: 2 }}>
              {t('migrationBanner.description')}
            </Typography>
            <Typography variant='body2' color='text.primary'>
              <Link
                href='https://www.almainsights.fi/alma-yritystunnus/'
                target='_blank'
                rel='noopener noreferrer'
                variant='body2'
                color='primary'
                sx={{ textDecoration: 'underline' }}
              >
                {t('migrationBanner.faqLink')}
              </Link>
              {' tai ole yhteydessä asiakaspalveluumme '}
              <Link
                href='mailto:sisaltopalvelut@almainsights.fi'
                variant='body2'
                color='primary'
                sx={{ textDecoration: 'underline' }}
              >
                {t('migrationBanner.customerSupportLink')}
              </Link>
            </Typography>
          </Box>

          <Box
            sx={{
              display: FLEX_DISPLAY,
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              alignSelf: { xs: 'stretch', md: 'center' },
            }}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => actions?.register()}
              sx={{ minWidth: { md: 197 } }}
            >
              {t('migrationBanner.registerButton')}
            </Button>
            <Link
              component='button'
              onClick={() => setIsVisible(false)}
              variant='subtitle2'
              color='primary'
              sx={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              {t('migrationBanner.skipLink')}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
